import React, {Component} from 'react';
import './cartaDesayuno.css'

class CartaDesayuno extends Component{
    constructor(props){
      super(props);
      this.item = props.item;
      this.precio = props.precio;
      this.id= props.id;
      this.handleCountDesayuno=this.handleCountDesayuno.bind(this);

    }

    handleCountDesayuno(id,item,precio){
        this.props.countDesayuno(id,item,precio)
    }
    
    render(){
        return(
                <button onClick={()=>{this.handleCountDesayuno(this.id,this.item,this.precio)}} className="cont">
                {this.item}<br/>
                <p>s/{this.precio}</p>
                </button>
        )
    }
}

export default CartaDesayuno;